var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import { publicAppSearchQuery } from './publicAppSearchQuery';
const DEFAULT_LIMIT = 20;
const timeoutIds = new WeakMap();
const simpleDebounce = (fn, delay) => (...args) => {
    clearTimeout(timeoutIds.get(fn));
    const timeoutId = setTimeout(() => {
        fn(...args);
    }, delay);
    timeoutIds.set(fn, timeoutId);
};
export const useAppSearchData = ({ limit, searchDebounceDelay, excludeUpcoming, useQuery, }) => {
    var _a;
    const [searchQuery, setSearchQuery] = useState('');
    const variables = {
        limit: limit || DEFAULT_LIMIT,
        nameContains: searchQuery,
        excludeUpcoming,
    };
    const _b = useQuery(publicAppSearchQuery, {
        variables,
        skip: searchQuery.trim() === '',
    }), { data } = _b, graphqlQueryControls = __rest(_b, ["data"]);
    const apps = ((_a = data === null || data === void 0 ? void 0 : data.getAppsByNameContains) === null || _a === void 0 ? void 0 : _a.edges) || [];
    return Object.assign(Object.assign({}, graphqlQueryControls), { onSearch: simpleDebounce(setSearchQuery, searchDebounceDelay || 0), searchQuery,
        apps });
};
//# sourceMappingURL=useAppSearchData.js.map
// @zapier/design-system-patterns@4.9.1 (4902ab0c1)
